<script setup lang="ts">
import { computed } from 'vue'

import { TextInput } from '@collector/shared-ui'

type Props = {
  withValidationStyle?: boolean
  disabled?: boolean
}
const props = defineProps<Props>()

// model
const model = defineModel<string | null>({ default: null })

// computed
const inputClass = computed(() => {
  return `w-12 text-center font-bold text-sm! ${getBorderClass()}`
})

// methods
function getBorderClass(): string {
  if (
    props.withValidationStyle &&
    (model.value === null || model.value.toString().length === 0)
  )
    return '!border-error-6'
  else return ''
}
</script>

<template>
  <TextInput
    v-model="model"
    placeholder="Nr"
    :inputClass
    :maxlength="3"
    :disabled
    numeric
  />
</template>
